import React, { useContext } from 'react';

import { RouterContext } from 'common/containers/RouterContainer';
import AdminQueueAlert, {
  AlertTypes,
} from 'common/subdomain/admin/AdminQueue/AdminQueueAlerts/AdminQueueAlert';
import ButtonV2 from 'common/ui/ButtonV2';
import { P } from 'common/ui/Text';

const AdminQueueCreditLimit = () => {
  const router = useContext(RouterContext);

  return (
    <AdminQueueAlert
      type={AlertTypes.error}
      text={
        <P>
          Your Autopilot credits have run out, and feedback processing has stopped. To continue
          receiving insights and feedback, please purchase more&nbsp;credits.
        </P>
      }
      actions={
        <ButtonV2 onClick={() => router.push('/admin/settings/billing/autopilot')} size="medium">
          Purchase credits
        </ButtonV2>
      }
    />
  );
};

export default AdminQueueCreditLimit;
